<template>
  <div class="common-box">
    <el-row class="row-one">
      <span class="row-one-title">组合持仓明细</span>
      <span class="row-one-subTitle">{{$route.params.row.funddesc}}</span>
      <Reback v-show="this.$route.name !== 'myAssets'" class="row-one-fr" @click.native="$router.go(-1)"></Reback>
    </el-row>
    <div class="adjustBox">
      <el-form :model="tableForm1" class="table-normal-form ">
        <table class="table-normal-one" cellspacing="0" id="table">
          <thead>
            <tr>
              <th>{{this.$route.params.row.funddesc}}</th>
              <th></th>
              <th>持有组合</th>
              <th>标准组合</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item,i) in fundListsTableData" :key="i">
              <td style="text-align: center;">{{item.fundType}}</td>
              <td style="width:200px;">{{item.fundcodename}}<span class="aColor"> {{item.fundcode}}</span></td>
              <td>{{item.proportion}}</td>
              <td>{{item.standard}}</td>
            </tr>
            </tr>
            <tr class="tr-one">
              <td style="text-align: center;">持仓差异</td>
              <td></td>
              <td></td>
              <td>{{this.$route.params.row.different}}</td>
            </tr>
            <tr class="tr-one">
              <td style="text-align: center;">调仓费用</td>
              <td></td>
              <td></td>
              <td>{{parseFloat(charge).toFixed(2)}}元</td>
            </tr>
          </tbody>
        </table>
        <p class="margin-t20">组合持仓与标准组合持仓差异大于10%时，建议您跟进调整仓位，是否进行调仓操作请您自行决定。</p>
        <div class="margin-t30">
          <el-button type="normal" style="background:#aaa;border-color:#aaa;margin-right:20px;" @click="$router.go(-1)">暂不调仓</el-button>
          <el-button type="normal" @click="dialogVisable = true">立刻调仓</el-button>
        </div>

      </el-form>
    </div>
    <!-- 支付密码 -->
    <el-dialog class="dialog-single-three" :visible.sync="dialogVisable" :close-on-click-modal="false" :before-close="adjustReturn">
      <div class="dialog-single-three-p">请输入支付密码</div>
      <el-form :model="adjustForm" ref="adjustFormRef" class="margin-t20" style="position: relative;">
        <el-form-item label="活动名称" prop="name" style="display:none;">
          <el-input v-model="adjustForm.name"></el-input>
        </el-form-item>
        <el-form-item prop="pass">
          <el-input ref="psdRef" v-model="adjustForm.pass" type="password" autocomplete="new-password" @blur="passBlur" @keyup.enter.native="submit" show-password></el-input>
          <span class="dialog-single-three-error" v-show="errorShow">{{errorMessage}}</span>
        </el-form-item>
      </el-form>
      <div class="margin-t35">
        <el-button type="normal1" @click="submit">{{submitText}}</el-button>
        <el-button type="adjust" style="width:154px" @click="adjustReturn">返回</el-button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
import $ from 'jquery'
export default {
  data () {
    return {
      tableForm1: {
        price: '',
        pwd: '',
        zhouqi: '',
        type: '1'
      },
      charge: '',
      message: '',
      //   密码
      dialogVisable: false,
      adjustForm: {
        name: '',
        pass: ''
      },
      errorShow: false,
      errorMessage: '',
      type: '',
      fundListsTableData: [],
      submitText: '确定',
    }
  },
  created () {
    this.message = this.$route.params.row
    console.log(this.message);
    this.getStandard()
    this.getRate()

  },
  mounted () {
  },
  methods: {
    // 标准组合
    getStandard () {
      let id = this.getCode(this.message.combinationcode)
      this.$http.post(this.$apiPath.jingZhunChangeRecord, {
        id: id,
      }).then(res => {
        // console.log(res);
        if (res.data.code == 200) {
          for (let i1 = 0; i1 < res.data.data.length; i1++) {
            const item1 = res.data.data[i1];
            item1.Fundlist.forEach(item => {
              item.fundcode = item.FundCode
              item.fundcodename = item.FundName
              item.standard = item.FundPro
              item.fundType = item1.Fundtype
              item.proportion = '0.0%'
            })
            item1.newArr = [];
            item1.mergeArr = [];
            for (let i2 = 0; i2 < this.message.children.length; i2++) {
              const item2 = this.message.children[i2];
              item2.fundType = item2.fundType.replace("基金", "")
              if (item1.Fundtype == item2.fundType.replace("基金", "")) {
                item1.newArr.push(item2)
              }
            }
            item1.mergeArr = this.merge(item1.Fundlist, item1.newArr)
          }
          let newfundListsTableData = []
          res.data.data.forEach(item1 => {
            item1.mergeArr.forEach(item2 => {
              newfundListsTableData.push(item2)
            })
          })
          this.fundListsTableData = newfundListsTableData
          //   console.log(this.fundListsTableData);
          this.mc('table', 0, 0, 0);
        }
      })

    },
    mc (tableId, startRow, endRow, col) {
      var tb = document.getElementById('table');
      //设置为0时,检索所有行
      if (endRow == 0) {
        endRow = tb.rows.length - 1;
      }
      //指定数据行索引大于表格行数
      if (endRow >= tb.rows.length) {
        return;
      }
      //检测指定的列索引是否超出表格列数
      if (col >= tb.rows[0].cells.length) {
        return;
      }
      //循环需要判断的数据行
      for (var i = startRow; i < endRow; i++) {
        //如果当前行与下一行数据值相同，则进行前面列的判断
        if (tb.rows[startRow].cells[col].innerHTML == tb.rows[i + 1].cells[col].innerHTML) {
          var Same = true;
          //循环跟前面的所有的同级数据行进行判断
          for (var j = col; j > 0; j--) {
            if (tb.rows[startRow].cells[j - 1].innerHTML != tb.rows[i + 1].cells[j - 1].innerHTML) {
              Same = false;
              break;
            }
          }
          //如果前面的同级数据行的值均相同，则进行单元格的合并
          if (true == Same) {
            //如果相同则删除下一行的第0列单元格  
            tb.rows[i + 1].cells[col].style.display = 'none';
            //更新rowSpan属性  
            tb.rows[startRow].cells[col].rowSpan = (tb.rows[startRow].cells[col].rowSpan | 0) + 1;
          }
          else {
            //增加起始行  
            startRow = i + 1;
          }
        }
        else {
          //增加起始行  
          startRow = i + 1;
        }
      }
    },
    // 合并数组
    merge (arr1, arr2) {
      let arr = []
      for (var i = arr1.length - 1; i >= 0; i--) {
        for (var j = 0; j < arr2.length; j++) {
          if (arr1[i].FundCode == arr2[j].fundcode) {
            arr1.splice(i, 1)
            break;
          }
        }
      }
      arr = arr2.concat(arr1)
      return arr
    },
    // 调仓费用
    getRate () {
      this.$http.get(this.$apiPath.getEstimatedFee, {
        custno: this.$commonJs.getCookie('u_custno1'),
        combinationcode: this.message.combinationcode,
        transactionaccountid: this.message.transactionaccountid
      }).then(res => {
        if (res.status == 200) {
          this.charge = this.$commonJs.getJsonByXml(res.data).estimatedfee.charge
        }
      }).catch(err => { })
    },
    // 确认调仓
    submit () {
      if (this.adjustForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
        var inputpwd = this.$des.enString(this.adjustForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3)
        var reallypass = this.$commonJs.getCookie('Password')
        if (inputpwd != reallypass) {
          this.errorShow = true
          this.errorMessage = "密码输入错误"
        } else {
          this.errorShow = false
          this.errorMessage = ""
          this.submitText = "确定中..."
          this.adjustOrder()
        }
      }

    },
    // 调仓
    adjustOrder () {
      this.$http.post(this.$apiPath.getTiaocangNew, {
        passwd: this.$des.enString(this.adjustForm.pass, this.$store.state.DESKEY.key1, this.$store.state.DESKEY.key2, this.$store.state.DESKEY.key3),
        sessionId: this.$commonJs.getCookie('sessionid'),
        appnew: '1',
        combinationcode: this.message.combinationcode, //组合代码
        transactionaccountid: this.message.transactionaccountid, //交易账号
        moneyaccount: this.message.moneyaccount, //资金账号
      }).then(res => {
        console.log(res);
        this.submitText = "确定"
        if (res.code == "0000") {
          this.adjustReturn()
          this.$message.success('调仓成功')
        } else {
          this.$message.error('调仓失败')
        }
      }).catch(err => { })

    },
    // 密码
    passBlur () {
      if (this.adjustForm.pass.trim() == "") {
        this.errorShow = true
        this.errorMessage = "请输入密码"
      } else {
        this.errorShow = false
        this.errorMessage = ""
      }
    },
    adjustReturn () {
      this.dialogVisable = false
      this.errorShow = false
      this.$refs.adjustFormRef.resetFields()
    },
    getCode (code) {
      var id
      if (code == "ZHZ001") {
        id = 1
      } else if (code == "ZHZ002") {
        id = 2
      } else if (code == "ZHZ003") {
        id = 3
      } else if (code == "ZH0034") {
        id = 4
      } else if (code == "ZHZ000") {
        id = 5
      } else if (code == "ZH0004") {
        id = 6
      }
      return id
    }
  }
}
</script>

<style lang="less">
.adjustBox {
  width: 621px;
  margin: 30px auto;
  text-align: center;
  td:first-child {
    width: 25%;
    text-align: center;
  }
}
</style>